module.exports = "@media screen and (max-width: 767px) {\n    p {\n        margin: 0 6px 10px;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/albums/album-item/album-item.component.css
// module id = ./src/app/albums/album-item/album-item.component.css
// module chunks = main